import React, { useEffect, useState } from "react";

import { Pagination } from "react-bootstrap"

//
const PaginationComponent = ({ rowCount, currentPage, setCurrentPage, pageLimit, dataLimit }) => {
  const [pages, setPages] = useState(1);

  useEffect(() => {
    setPages(rowCount >= dataLimit ? Math.ceil(rowCount / dataLimit) : 1);
  }, [rowCount])

  const goToFirstPage = () => {
    setCurrentPage(1);
  }

  const goToNextPage = () => {
    setCurrentPage((page) => page + 1);
  }

  const goToPreviousPage = () => {
    setCurrentPage((page) => page - 1);
  }

  const goToLastPage = () => {
    setCurrentPage(pages);
  }

  const changePage = (event) => {
    const pageNumber = Number(event.target.textContent);
    setCurrentPage(pageNumber);
  }

  const getPaginationGroup = () => {
    let rows = (pageLimit > pages) ? pages : pageLimit;
    let start = Math.floor((currentPage - 1) / rows) * rows;
    const resArr = new Array(rows)
      .fill()
      .map((_, idx) => start + idx + 1)
      .filter((item) => item <= pages)
    return resArr;
  }

  return (
    <Pagination
      aria-label="Page navigation"
      className="d-flex justify-content-center"
    >
      <Pagination.First
        href="#"
        activeLabel={''}
        onClick={goToFirstPage}
        disabled={currentPage === 1}
      />
      <Pagination.Prev
        href="#"
        activeLabel={''}
        onClick={goToPreviousPage}
        disabled={currentPage === 1}
      />
      {getPaginationGroup().map((item, index) => (
        <Pagination.Item
          href="#"
          onClick={changePage}
          activeLabel={''}
          active={currentPage === item}
          key={index}
        >{item}
        </Pagination.Item>
      ))}
      <Pagination.Next
        href="#"
        onClick={goToNextPage}
        disabled={currentPage === pages}
      />
      <Pagination.Last
        href="#"
        onClick={goToLastPage}
        disabled={currentPage === pages}
      />

      {/*  <Pagination.Item className={`${currentPage === 1 ? 'disabled' : ''}`}>
        <Pagination.Link href="#" onClick={goToFirstPage}>
          <i className="fa fa-angle-double-left" />
        </Pagination.Link>
      </Pagination.Item>
      <Pagination.Item className={`${currentPage === 1 ? 'disabled' : ''}`}>
        <Pagination.Link href="#" onClick={goToPreviousPage}>
          <i className="fa fa-angle-left" />
        </Pagination.Link>
      </Pagination.Item>
     
      {getPaginationGroup().map((item, index) => (
        <Pagination.Item
          className={`${currentPage === item ? 'active' : null}`}
          key={index}
        >
          <Pagination.Link href="#" onClick={changePage}>{item}</Pagination.Link>
        </Pagination.Item>
      ))}
      <Pagination.Item className={`${currentPage === pages ? 'disabled' : ''}`}>
        <Pagination.Link href="#" onClick={goToNextPage}>
          <i className="fa fa-angle-right" />
        </Pagination.Link>
      </Pagination.Item>
      <Pagination.Item className={`${currentPage === pages ? 'disabled' : ''}`}>
        <Pagination.Link href="#" onClick={goToLastPage}>
          <i className="fa fa-angle-double-right" />
        </Pagination.Link>
      </Pagination.Item> */}

    </Pagination>
  );
}

export default PaginationComponent;